export default "__VITE_ASSET__CAi6hba$__"